import { render, staticRenderFns } from "./FAQS_2nd_col.vue?vue&type=template&id=4166aca5&scoped=true"
import script from "./FAQS_2nd_col.vue?vue&type=script&lang=js"
export * from "./FAQS_2nd_col.vue?vue&type=script&lang=js"
import style0 from "./FAQS_2nd_col.vue?vue&type=style&index=0&id=4166aca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4166aca5",
  null
  
)

export default component.exports